import moment from "moment-timezone";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Header, Form } from "semantic-ui-react";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class ISOWeekDateRange extends PureComponent {
  static propTypes = {
    from: PropTypes.string,
    to: PropTypes.string,
    min: PropTypes.string,
    max: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false
  };

  constructor(props) {
    super(props);
    this.state = this.calculateValues();
  }

  // -- DATA MANAGEMENT -- //

  calculateValues = () => {
    const { from, min, max } = this.props;

    // set start and end of current month
    const weekStart = moment.utc().startOf("isoWeek");
    const weekEnd = moment.utc().endOf("isoWeek");

    // ensure min is set to the beginning of the month and max to the end
    // fallback to current month if no min max is passed
    const _min = min ? moment.utc(min).startOf("isoWeek") : weekStart;
    const _max = max ? moment.utc(max).endOf("isoWeek") : weekEnd;

    // clamp _from to _min value
    // fallback to current month if no from value is passed
    let _from = weekStart;
    if (from) {
      _from = moment.utc(from).startOf("isoWeek");
      _from = _from.unix() < _min.unix() ? _min.clone() : _from;
    }

    // don't currently need use the _to value but leaving for completion's sake
    // clamp _to to _max value
    // fallback to current month if no to value is passed
    // let _to = monthEnd;
    // if (to) {
    //   _to = moment(to).endOf("month");
    //   _to = _to.unix() < _max.unix() ? _max.clone() : _to;
    // }

    const _year = moment.utc(_from).year().toString();
    const _week = _from.toISOString();

    return {
      _year,
      _week,
      _min,
      _max
    };
  };

  // -- HANDLERS -- //
  onYearChange = (event, data) => {
    // reset month to first month available in the selected year
    const weeks = this.getWeekOptionsByYear(data.value);

    this.setState({ _year: data.value, _week: weeks[0].value }, this.doSubmit);
  };

  onWeekChange = (event, data) => {
    this.setState({ _week: data.value }, this.doSubmit);
  };

  doSubmit = () => {
    const { _week } = this.state;

    const week = moment.utc(_week);

    const from = week.clone();
    const to = week.endOf("isoWeek");

    this.props.onChange(from, to);
  };

  // -- RENDER -- //

  getYearOptions = () => {
    const { _min, _max } = this.state;

    let years = [];
    let year = _min.clone();

    while (year.isoWeekYear() <= _max.isoWeekYear()) {
      years.push({ text: year.isoWeekYear(), value: year.format("YYYY") });
      year.add(1, "y");
    }

    return years;
  };

  getWeekOptionsByYear = year => {
    const { _min, _max } = this.state;

    // needs to be based on selected year rather than wrapping 12 months
    // can't use the 1st of jan as this will likely be in the previous isoWeekYear
    const yearMoment = moment.utc(`${year}-02-02`);

    let start = null;
    let end = null;

    if (_min.isoWeekYear() === yearMoment.isoWeekYear()) {
      start = _min.isoWeek();
    } else {
      start = 1;
    }

    if (_max.isoWeekYear() === yearMoment.isoWeekYear()) {
      end = _max.isoWeek();
    } else {
      end = yearMoment.isoWeeksInYear();
    }

    let weeks = [];

    for (let i = start; i <= end; i++) {
      weeks.push({
        text: `Week ${i}`,
        value: yearMoment.isoWeek(i).startOf("isoWeek").toISOString()
      });
    }

    return weeks;
  };

  render() {
    const { disabled, copy } = this.props;
    const { _year, _week } = this.state;

    return (
      <Form>
        <Header as="h3">{copy("usage.date_range.title")}</Header>
        <Form.Group widths="equal">
          <Form.Dropdown
            selection
            fluid
            options={this.getYearOptions()}
            value={_year}
            disabled={disabled}
            onChange={this.onYearChange}
          />
          <Form.Dropdown
            selection
            fluid
            options={this.getWeekOptionsByYear(_year)}
            value={_week}
            disabled={disabled}
            onChange={this.onWeekChange}
          />
        </Form.Group>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ISOWeekDateRange);
